import { OwnerSquad } from '@/analytics/generated/segment'
import type { GuideTourDefinition } from '@/guide-tour/types'

const OWNER_SQUADS = new Set<string>(Object.values(OwnerSquad))

export const validateOwnerSquads = (
  tours: readonly GuideTourDefinition[]
): void => {
  for (const tour of tours) {
    if (!OWNER_SQUADS.has(tour.ownerSquad)) {
      throw new Error(
        `Tour "${tour.id}" has invalid ownerSquad "${tour.ownerSquad}". Use a Segment OwnerSquad value.`
      )
    }
  }
}
